// editar

import { Injectable } from '@angular/core';

import { Action } from '@core/components/actions/action.default';

@Injectable()
export class EditarAction extends Action {

  constructor() {
    super();
  }

}
